/**
 * Check whether the user provided a value.
 */
import { FormikValues, getIn } from 'formik';

export const FORMIK_REQUIRED: string = 'Dit veld is verplicht';
export const FORMIK_EMAIL: string = 'Het opgegeven e-mailadres is niet geldig';
export const FORMIK_PHONE: string = 'Het opgegeven telefoonnummer is niet geldig';
export const FORMIK_PUPIL_EMAIL: string = 'Het e-mailadres van ouder en leerling kan niet gelijk zijn';

/**
 * Validate if there is a value. Formik returns empty fields
 * as an empty string. This method will return an error in
 * this case.
 */
export function validateRequired(value: string): string {
  return (!value) ? FORMIK_REQUIRED : undefined;
}

/**
 * Validate the provided email.
 * In generic email validators. The user doesn't have to provide an
 * extension like .nl. We wrote our own regex, which does require this.
 */
export function validateEmail(value: string): string {
  const regex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
  if (!!value && !regex.test(value)) {
    return FORMIK_EMAIL;
  }

  return undefined;
}

/**
 * Validate if the provided field is not equal to the
 * other provided field.
 */
export function validateNotEqualTo(
  value: string,
  values: FormikValues,
  matchPath: string,
  error: string): string {
  return (!!value && getIn(values, matchPath) === value) ? error : undefined;
}

/**
 * Validate whether the phone number is a dutch phone number or mobile.
 * (ignores spaces)
 */
export function validatePhone(value: string): string {
  value = value.replace(/\s*/g,'');

  const phone: RegExp = /^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))$/;
  const mobile: RegExp = /^(((\+31|0|0031)6){1}[1-9]{1}[0-9]{7})$/i;

  if (!!value && !(phone.test(value) || mobile.test(value))) {
    return FORMIK_PHONE;
  }

  return undefined;
}

